import { useEffect, useMemo, createContext, useReducer, useContext, memo } from 'react';
import { LogLevel, BrowserCacheLocation, AuthenticationScheme, PublicClientApplication, InteractionRequiredAuthError, AuthError, InteractionStatus, InteractionType } from '@azure/msal-browser';
import { useMsal, useAccount, useMsalAuthentication, MsalProvider } from '@azure/msal-react';
export * from '@azure/msal-react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import queryString from 'query-string';
import { useAsync } from '@bps/hooks';

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$7(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$2(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator$1(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var config;
var appInstance;
var loginRequest;
var logoutRequest;
var MSAL_INTERACTION_STATUS = "msal.interaction.status";
var getLogSink = function(logLevel) {
    switch(logLevel){
        case LogLevel.Warning:
            // eslint-disable-next-line no-console
            return console.warn;
        case LogLevel.Error:
            // eslint-disable-next-line no-console
            return console.error;
        case LogLevel.Trace:
        case LogLevel.Verbose:
            // eslint-disable-next-line no-console
            return console.debug;
        case LogLevel.Info:
        default:
            // eslint-disable-next-line no-console
            return console.log;
    }
};
var loggerCallback = function(logLevel, message) {
    return getLogSink(logLevel)(message);
};
/**
 * Set up the Authenticator instance with runtime configuration.
 * @param options Runtime configuration
 */ var getMsalInstance = function(options) {
    var scopes = options.scopes, cacheLocation = options.cacheLocation, logLevel = options.logLevel, postAuthenticateRedirectUrl = options.postAuthenticateRedirectUrl, redirectUri = options.redirectUri, extraQueryParameters = options.extraQueryParameters, authConfig = _object_without_properties$2(options, [
        "scopes",
        "cacheLocation",
        "logLevel",
        "postAuthenticateRedirectUrl",
        "redirectUri",
        "extraQueryParameters"
    ]);
    config = {
        auth: _object_spread$7({
            redirectUri: redirectUri || postAuthenticateRedirectUrl,
            postLogoutRedirectUri: postAuthenticateRedirectUrl || redirectUri,
            navigateToLoginRequestUrl: false
        }, authConfig),
        cache: {
            cacheLocation: cacheLocation !== null && cacheLocation !== void 0 ? cacheLocation : BrowserCacheLocation.LocalStorage
        },
        system: {
            loggerOptions: {
                loggerCallback: loggerCallback,
                logLevel: logLevel !== null && logLevel !== void 0 ? logLevel : LogLevel.Warning
            }
        }
    };
    loginRequest = {
        scopes: scopes,
        authenticationScheme: AuthenticationScheme.BEARER,
        redirectUri: redirectUri || postAuthenticateRedirectUrl || undefined,
        extraQueryParameters: extraQueryParameters
    };
    logoutRequest = {
        postLogoutRedirectUri: postAuthenticateRedirectUrl || redirectUri || undefined,
        extraQueryParameters: {
            // eslint-disable-next-line camelcase
            client_id: config.auth.clientId
        }
    };
    appInstance = new PublicClientApplication(config);
    return appInstance;
};
/**
 * Get the MSAL instance that the Authenticator is using. If the Authenticator has not been configured, this will throw
 * an error.
 * @returns {PublicClientApplication} The MSAL instance.
 * @throws {Error} The Authenticator has not been configured.
 */ var getAppInstance = function() {
    if (appInstance) return appInstance;
    throw new Error("MSAL has not been configured. Call `configure` first.");
};
/**
 * Tries to get the active MSAL account based on the user's token.
 *
 * @returns {AccountInfo | undefined}
 */ // @TODO probably we won't need this method. Ilya S.
var getActiveAccount = function() {
    var _ref = _async_to_generator$1(function() {
        var msal, account, accounts, redirectRes;
        return _ts_generator$1(this, function(_state) {
            switch(_state.label){
                case 0:
                    msal = getAppInstance();
                    account = msal.getActiveAccount();
                    if (account) return [
                        2,
                        account
                    ];
                    accounts = msal.getAllAccounts();
                    if (accounts.length) {
                        return [
                            2,
                            accounts[0]
                        ];
                    }
                    return [
                        4,
                        msal.handleRedirectPromise()
                    ];
                case 1:
                    redirectRes = _state.sent();
                    if (redirectRes === null || redirectRes === void 0 ? void 0 : redirectRes.account) {
                        return [
                            2,
                            redirectRes.account
                        ];
                    }
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return function getActiveAccount() {
        return _ref.apply(this, arguments);
    };
}();
var resetMsalState = function(msal, matchClientIdOnResetInteraction) {
    var isInProgress = msal["browserStorage"].isInteractionInProgress(matchClientIdOnResetInteraction);
    if (isInProgress) {
        msal["browserStorage"].removeItem(MSAL_INTERACTION_STATUS);
    }
};
/**
 * Performs a `loginRedirect` requesting using the default options (from when Authenticator was bootstrapped):
 *
 * ```
 * {
 *     authenticationScheme: 'Bearer',
 *     scopes: options.scopes,
 *     redirectUri: options.postAuthenticateRedirectUrl,
 * }
 * ```
 * preferentially to the default options.
 * @param redirectRequestOptions
 */ var login = function() {
    var _ref = _async_to_generator$1(function(redirectRequestOptions) {
        var _ref, resetInteractionInProgressStatus, matchClientIdOnResetInteraction, rest, msal;
        return _ts_generator$1(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = redirectRequestOptions || {}, resetInteractionInProgressStatus = _ref.resetInteractionInProgressStatus, matchClientIdOnResetInteraction = _ref.matchClientIdOnResetInteraction, rest = _object_without_properties$2(_ref, [
                        "resetInteractionInProgressStatus",
                        "matchClientIdOnResetInteraction"
                    ]);
                    msal = getAppInstance();
                    // Optionally, reset interaction in progress status.
                    if (resetInteractionInProgressStatus) {
                        resetMsalState(msal, matchClientIdOnResetInteraction);
                    }
                    return [
                        4,
                        msal.handleRedirectPromise()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        msal.loginRedirect(_object_spread$7({}, loginRequest, rest))
                    ];
            }
        });
    });
    return function login(redirectRequestOptions) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Attempts to acquire an access token for the logged in account using `acquireTokenSilent`.
 *
 * @param required Specifies if the access token is mandatory. Defaults to `false`.
 * @param willRedirect
 * @throws {Error} When `required` is `true` but no active account exists or a token could not be acquired.
 */ var getAccessToken = function() {
    var _ref = _async_to_generator$1(function() {
        var required, willRedirect, fail, account, msal, authResult, _authResult_accessToken, error, redirectResult;
        var _arguments = arguments;
        return _ts_generator$1(this, function(_state) {
            switch(_state.label){
                case 0:
                    required = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false, willRedirect = _arguments.length > 1 ? _arguments[1] : void 0;
                    fail = function(reason) {
                        if (!required) return undefined;
                        // Extra redirect callback
                        willRedirect === null || willRedirect === void 0 ? void 0 : willRedirect(msal);
                        throw new Error(reason);
                    };
                    return [
                        4,
                        getActiveAccount()
                    ];
                case 1:
                    account = _state.sent();
                    if (!account) {
                        return [
                            2,
                            fail("Could not acquire an access token - there is no logged in account")
                        ];
                    }
                    msal = getAppInstance();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        10
                    ]);
                    return [
                        4,
                        msal.acquireTokenSilent(_object_spread_props$5(_object_spread$7({}, loginRequest), {
                            account: account
                        }))
                    ];
                case 3:
                    authResult = _state.sent();
                    return [
                        2,
                        (_authResult_accessToken = authResult === null || authResult === void 0 ? void 0 : authResult.accessToken) !== null && _authResult_accessToken !== void 0 ? _authResult_accessToken : fail("Failed to acquire an access token")
                    ];
                case 4:
                    error = _state.sent();
                    if (!_instanceof(error, AuthError)) throw error;
                    // Extra redirect callback
                    willRedirect === null || willRedirect === void 0 ? void 0 : willRedirect(msal);
                    return [
                        4,
                        msal.handleRedirectPromise()
                    ];
                case 5:
                    redirectResult = _state.sent();
                    if (redirectResult === null || redirectResult === void 0 ? void 0 : redirectResult.accessToken) {
                        return [
                            2,
                            redirectResult.accessToken
                        ];
                    }
                    if (!required) return [
                        3,
                        9
                    ];
                    if (!InteractionRequiredAuthError.isInteractionRequiredError(error.errorCode, error.errorMessage, error.subError)) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        msal.acquireTokenRedirect(loginRequest)
                    ];
                case 6:
                    _state.sent();
                    return [
                        3,
                        9
                    ];
                case 7:
                    // We have to consider any token information that we have as invalid, so force logout to
                    // let the user log back in.
                    return [
                        4,
                        msal.logoutRedirect(logoutRequest)
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        10
                    ];
                case 10:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return function getAccessToken() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Performs a `logoutRedirect` requesting using the default options (from when Authenticator was bootstrapped):
 *
 * ```
 * {
 *     postLogoutRedirectUri: options.postAuthenticateRedirectUrl,
 *     extraQueryParameters: {
 *         clientId: options.auth.clientId,
 *     },
 * }
 * ```
 * @param request Additional options to pass to the `logoutRedirect` call. Any options passed here are used
 * preferentially to the default options.
 */ var logout = function() {
    var _ref = _async_to_generator$1(function(request) {
        var _ref, resetInteractionInProgressStatus, matchClientIdOnResetInteraction, restLogoutRequestOptions, msal;
        return _ts_generator$1(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = request || {}, resetInteractionInProgressStatus = _ref.resetInteractionInProgressStatus, matchClientIdOnResetInteraction = _ref.matchClientIdOnResetInteraction, restLogoutRequestOptions = _object_without_properties$2(_ref, [
                        "resetInteractionInProgressStatus",
                        "matchClientIdOnResetInteraction"
                    ]);
                    msal = getAppInstance();
                    // Optionally, reset interaction in progress status.
                    if (resetInteractionInProgressStatus) {
                        resetMsalState(msal, matchClientIdOnResetInteraction);
                    }
                    return [
                        4,
                        msal.logoutRedirect(_object_spread$7({}, logoutRequest, restLogoutRequestOptions))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function logout(request) {
        return _ref.apply(this, arguments);
    };
}();

var VISIBILITY_STATE = "visible";
var APP_VISIBILITY_EVENT = "visibilitychange";
/**
 * Utility to sign out a user session if an app's switched from hidden to visible state
 * and the user session is invalid (expired).
 */ var useAppSignOut = function(request) {
    var logoutHandler = function() {
        if (document.visibilityState === VISIBILITY_STATE) {
            getAccessToken().then(function(token) {
                if (!token) {
                    logout();
                }
            }).catch(function() {
                return logout(request);
            });
        }
    };
    useEffect(function() {
        document.addEventListener(APP_VISIBILITY_EVENT, logoutHandler);
        return function() {
            document.removeEventListener(APP_VISIBILITY_EVENT, logoutHandler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

var InteractionStatusText;
(function(InteractionStatusText) {
    InteractionStatusText["Startup"] = "Initialising...";
    InteractionStatusText["Checking"] = "Checking your login details...";
    InteractionStatusText["Login"] = "Logging in...";
    InteractionStatusText["Logout"] = "Logging out...";
})(InteractionStatusText || (InteractionStatusText = {}));
var useMsalProgressStatus = function() {
    var inProgress = useMsal().inProgress;
    switch(inProgress){
        case InteractionStatus.Startup:
        case InteractionStatus.HandleRedirect:
            return "Initialising...";
        case InteractionStatus.AcquireToken:
        case InteractionStatus.SsoSilent:
            return "Checking your login details...";
        case InteractionStatus.Login:
            return "Logging in...";
        case InteractionStatus.Logout:
            return "Logging out...";
        case InteractionStatus.None:
        default:
            return null;
    }
};

var MsalLocalStorageKeys;
(function(MsalLocalStorageKeys) {
    MsalLocalStorageKeys["BpMsalSessions"] = "bp:sessions";
})(MsalLocalStorageKeys || (MsalLocalStorageKeys = {}));

var AuthMethod;
(function(AuthMethod) {
    AuthMethod["Password"] = "pwd";
    AuthMethod["Pin"] = "pin";
})(AuthMethod || (AuthMethod = {}));

var BpIdHints;
(function(BpIdHints) {
    BpIdHints["Bpt"] = "bpt_hint";
    BpIdHints["Bpu"] = "bpu_hint";
    BpIdHints["Login"] = "login_hint";
    BpIdHints["IdToken"] = "id_token_hint";
    BpIdHints["Redirect"] = "redirect_hint";
    BpIdHints["SkipResumeSessions"] = "skip_resume_sessions";
})(BpIdHints || (BpIdHints = {}));

var AzureAdB2cErrorCodes;
(function(AzureAdB2cErrorCodes) {
    AzureAdB2cErrorCodes["UserExists"] = "AADB2C90001";
    AzureAdB2cErrorCodes["CORSResourceNotFound"] = "AADB2C90002";
    AzureAdB2cErrorCodes["RedirectURINotRegistered"] = "AADB2C90006";
    AzureAdB2cErrorCodes["NoRedirectURIs"] = "AADB2C90007";
    AzureAdB2cErrorCodes["MissingClientID"] = "AADB2C90008";
    AzureAdB2cErrorCodes["MissingScopeParam"] = "AADB2C90010";
    AzureAdB2cErrorCodes["ClientIDMismatch"] = "AADB2C90011";
    AzureAdB2cErrorCodes["UnsupportedScope"] = "AADB2C90012";
    AzureAdB2cErrorCodes["UnsupportedResponseType"] = "AADB2C90013";
    AzureAdB2cErrorCodes["UnsupportedResponseMode"] = "AADB2C90014";
    AzureAdB2cErrorCodes["ClientAssertionTypeMismatch"] = "AADB2C90016";
    AzureAdB2cErrorCodes["InvalidClientAssertion"] = "AADB2C90017";
    AzureAdB2cErrorCodes["ClientIDNotRegistered"] = "AADB2C90018";
    AzureAdB2cErrorCodes["InvalidKeyContainer"] = "AADB2C90019";
    AzureAdB2cErrorCodes["TechnicalProfileNotExist"] = "AADB2C90021";
    AzureAdB2cErrorCodes["MetadataReturnFailed"] = "AADB2C90022";
    AzureAdB2cErrorCodes["MissingMetadataKey"] = "AADB2C90023";
    AzureAdB2cErrorCodes["MissingCryptographicKey"] = "AADB2C90025";
    AzureAdB2cErrorCodes["InvalidBasicCredentials"] = "AADB2C90027";
    AzureAdB2cErrorCodes["InvalidClientCertificate"] = "AADB2C90028";
    AzureAdB2cErrorCodes["MissingDefaultUserJourney"] = "AADB2C90031";
    AzureAdB2cErrorCodes["ServiceUnavailable"] = "AADB2C90035";
    AzureAdB2cErrorCodes["MissingPostLogoutURI"] = "AADB2C90036";
    AzureAdB2cErrorCodes["ProcessingError"] = "AADB2C90037";
    AzureAdB2cErrorCodes["MissingClientSecret"] = "AADB2C90039";
    AzureAdB2cErrorCodes["MissingSendClaimsStep"] = "AADB2C90040";
    AzureAdB2cErrorCodes["InvalidPromptValues"] = "AADB2C90043";
    AzureAdB2cErrorCodes["UnsupportedClaim"] = "AADB2C90044";
    AzureAdB2cErrorCodes["TroubleLoadingState"] = "AADB2C90046";
    AzureAdB2cErrorCodes["ScriptErrors"] = "AADB2C90047";
    AzureAdB2cErrorCodes["UnhandledException"] = "AADB2C90048";
    AzureAdB2cErrorCodes["NoClaimsProviders"] = "AADB2C90051";
    AzureAdB2cErrorCodes["InvalidCredentials"] = "AADB2C90052";
    AzureAdB2cErrorCodes["UserNotFound"] = "AADB2C90053";
    AzureAdB2cErrorCodes["InvalidUsernameOrPassword"] = "AADB2C90054";
    AzureAdB2cErrorCodes["MissingResourceInScope"] = "AADB2C90055";
    AzureAdB2cErrorCodes["ImplicitFlowNotAllowed"] = "AADB2C90057";
    AzureAdB2cErrorCodes["PublicClientsNotAllowed"] = "AADB2C90058";
    AzureAdB2cErrorCodes["MissingCodeChallenge"] = "AADB2C99059";
    AzureAdB2cErrorCodes["InvalidPostLogoutRedirectURI"] = "AADB2C90067";
    AzureAdB2cErrorCodes["InvalidApplicationID"] = "AADB2C90068";
    AzureAdB2cErrorCodes["KeyContainerNotFound"] = "AADB2C90073";
    AzureAdB2cErrorCodes["ClaimsExchangeError"] = "AADB2C90075";
    AzureAdB2cErrorCodes["NoExistingSession"] = "AADB2C90077";
    AzureAdB2cErrorCodes["MissingConfidentialGrantSecret"] = "AADB2C90079";
    AzureAdB2cErrorCodes["ExpiredGrant"] = "AADB2C90080";
    AzureAdB2cErrorCodes["IncorrectClientSecret"] = "AADB2C90081";
    AzureAdB2cErrorCodes["MissingRequiredParameter"] = "AADB2C90083";
    AzureAdB2cErrorCodes["PublicClientSecretError"] = "AADB2C90084";
    AzureAdB2cErrorCodes["InternalServerError"] = "AADB2C90085";
    AzureAdB2cErrorCodes["UnsupportedGrantType"] = "AADB2C90086";
    AzureAdB2cErrorCodes["InvalidProtocolEndpoint"] = "AADB2C90087";
    AzureAdB2cErrorCodes["EndpointNotIssuedGrant"] = "AADB2C90088";
    AzureAdB2cErrorCodes["UserCancellation"] = "AADB2C90091";
    AzureAdB2cErrorCodes["ApplicationDisabled"] = "AADB2C90092";
    AzureAdB2cErrorCodes["IDTokenIssueError"] = "AADB2C90107";
    AzureAdB2cErrorCodes["MissingCpimIssuerReference"] = "AADB2C90108";
    AzureAdB2cErrorCodes["MissingOpenIdScope"] = "AADB2C90110";
    AzureAdB2cErrorCodes["AccountLocked"] = "AADB2C90111";
    AzureAdB2cErrorCodes["AccountTemporarilyLocked"] = "AADB2C90114";
    AzureAdB2cErrorCodes["MissingResourceOrClientID"] = "AADB2C90115";
    AzureAdB2cErrorCodes["ScopeNotSupported"] = "AADB2C90117";
    AzureAdB2cErrorCodes["ForgottenPassword"] = "AADB2C90118";
    AzureAdB2cErrorCodes["InvalidMaxAgeParameter"] = "AADB2C90120";
    AzureAdB2cErrorCodes["InvalidRequestInput"] = "AADB2C90122";
    AzureAdB2cErrorCodes["GrantNoLongerExists"] = "AADB2C90128";
    AzureAdB2cErrorCodes["RevokedGrant"] = "AADB2C90129";
    AzureAdB2cErrorCodes["NoVerifiedPhoneNumbers"] = "AADB2C90145";
    AzureAdB2cErrorCodes["ScopeSpecifiesMultipleResources"] = "AADB2C90146";
    AzureAdB2cErrorCodes["ScriptLoadFailed"] = "AADB2C90149";
    AzureAdB2cErrorCodes["MaxRetriesExceededForMFA"] = "AADB2C90151";
    AzureAdB2cErrorCodes["MultiFactorPollFailed"] = "AADB2C90152";
    AzureAdB2cErrorCodes["MultiFactorVerificationRequestFailed"] = "AADB2C90154";
    AzureAdB2cErrorCodes["MultiFactorVerificationRequestFailedWithReason"] = "AADB2C90155";
    AzureAdB2cErrorCodes["MultiFactorValidationRequestFailed"] = "AADB2C90156";
    AzureAdB2cErrorCodes["MaxRetriesExceededSelfAssert"] = "AADB2C90157";
    AzureAdB2cErrorCodes["SelfAssertedValidationRequestFailed"] = "AADB2C90158";
    AzureAdB2cErrorCodes["SelfAssertedVerificationRequestFailed"] = "AADB2C90159";
    AzureAdB2cErrorCodes["SelfAssertedSendResponseFailed"] = "AADB2C90161";
    AzureAdB2cErrorCodes["SAMLMessageNotFound"] = "AADB2C90165";
    AzureAdB2cErrorCodes["MissingSignedRequestParameter"] = "AADB2C90168";
    AzureAdB2cErrorCodes["MissingPrivateKey"] = "AADB2C90178";
    AzureAdB2cErrorCodes["CodeVerifierMismatch"] = "AADB2C90182";
    AzureAdB2cErrorCodes["InvalidCodeVerifier"] = "AADB2C90183";
    AzureAdB2cErrorCodes["UnsupportedCodeChallengeMethod"] = "AADB2C90184";
    AzureAdB2cErrorCodes["SAMLMetadataFetchFailed"] = "AADB2C90188";
    AzureAdB2cErrorCodes["InvalidBearerTokenClaim"] = "AADB2C90194";
    AzureAdB2cErrorCodes["InsufficientPermissions"] = "AADB2C90205";
    AzureAdB2cErrorCodes["ClientInitializationTimeout"] = "AADB2C90206";
    AzureAdB2cErrorCodes["ExpiredIDTokenHint"] = "AADB2C90208";
    AzureAdB2cErrorCodes["InvalidAudienceInIDTokenHint"] = "AADB2C90209";
    AzureAdB2cErrorCodes["IDTokenHintValidationFailed"] = "AADB2C90210";
    AzureAdB2cErrorCodes["IncompleteStateCookie"] = "AADB2C90211";
    AzureAdB2cErrorCodes["InvalidStateCookie"] = "AADB2C90212";
    AzureAdB2cErrorCodes["InvalidCertificateInKeyContainer"] = "AADB2C90220";
    AzureAdB2cErrorCodes["CORSResourceSanitizationError"] = "AADB2C90223";
    AzureAdB2cErrorCodes["ResourceOwnerFlowNotEnabled"] = "AADB2C90224";
    AzureAdB2cErrorCodes["InvalidUsernameOrPasswordInRequest"] = "AADB2C90225";
    AzureAdB2cErrorCodes["TokenExchangeOnlySupportedPost"] = "AADB2C90226";
    AzureAdB2cErrorCodes["InvalidIssuerInIDTokenHint"] = "AADB2C90232";
    AzureAdB2cErrorCodes["SignatureValidationFailedInIDTokenHint"] = "AADB2C90233";
    AzureAdB2cErrorCodes["ExpiredIDToken"] = "AADB2C90235";
    AzureAdB2cErrorCodes["InvalidAudienceInIDToken"] = "AADB2C90237";
    AzureAdB2cErrorCodes["InvalidIssuerInIDToken"] = "AADB2C90238";
    AzureAdB2cErrorCodes["SignatureValidationFailedInIDToken"] = "AADB2C90239";
    AzureAdB2cErrorCodes["MalformedIDToken"] = "AADB2C90240";
    AzureAdB2cErrorCodes["CannotLoadPartnerEntityCDATA"] = "AADB2C90242";
    AzureAdB2cErrorCodes["ImproperlyConfiguredIDP"] = "AADB2C90243";
    AzureAdB2cErrorCodes["TooManyRequests"] = "AADB2C90244";
    AzureAdB2cErrorCodes["ApplicationOnlyForB2CAdminPortal"] = "AADB2C90248";
    AzureAdB2cErrorCodes["GenericLoginNotSupported"] = "AADB2C90250";
    AzureAdB2cErrorCodes["ClaimsExchangeNotCompleted"] = "AADB2C90255";
    AzureAdB2cErrorCodes["ClaimsExchangeResponseParsingFailed"] = "AADB2C90261";
    AzureAdB2cErrorCodes["MissingIDTokenHintParameter"] = "AADB2C90272";
    AzureAdB2cErrorCodes["InvalidReceivedResponse"] = "AADB2C90273";
    AzureAdB2cErrorCodes["MissingLogoutServiceInMetadata"] = "AADB2C90274";
    AzureAdB2cErrorCodes["InconsistentControlSetting"] = "AADB2C90276";
    AzureAdB2cErrorCodes["MissingContentDefinitionReference"] = "AADB2C90277";
    AzureAdB2cErrorCodes["IncorrectClientIDInGrant"] = "AADB2C90279";
    AzureAdB2cErrorCodes["ConsentNotGranted"] = "AADB2C90284";
    AzureAdB2cErrorCodes["ApplicationNotFound"] = "AADB2C90285";
    AzureAdB2cErrorCodes["UserJourneyNotFound"] = "AADB2C90288";
    AzureAdB2cErrorCodes["InvalidRedirectURI"] = "AADB2C90287";
    AzureAdB2cErrorCodes["ErrorConnectingToIDP"] = "AADB2C90289";
    AzureAdB2cErrorCodes["InvalidClientErrorConnectingToIDP"] = "AADB2C90290";
    AzureAdB2cErrorCodes["IncorrectApplicationConfiguration"] = "AADB2C90296";
    AzureAdB2cErrorCodes["InvalidScopeParameter"] = "AADB2C99005";
    AzureAdB2cErrorCodes["ExtensionsAppNotFound"] = "AADB2C99006";
    AzureAdB2cErrorCodes["MissingMetadataValue"] = "AADB2C99011";
    AzureAdB2cErrorCodes["UnsupportedGrantTypeCombination"] = "AADB2C99013";
    AzureAdB2cErrorCodes["MissingInputClaims"] = "AADB2C99015";
    AzureAdB2cErrorCodes["UserDoesNotExist"] = "AADB2C99002";
    AzureAdB2cErrorCodes["MissingAuthorizationTechnicalProfile"] = "AADB2C99027"; // "Policy '{0}' does not contain an AuthorizationTechnicalProfile with a corresponding ClientAssertionType."
})(AzureAdB2cErrorCodes || (AzureAdB2cErrorCodes = {}));

var useMsalErrors = function(error) {
    return useMemo(function() {
        /** Check if b2c interaction required */ var isInteractionRequiredError = !!error && InteractionRequiredAuthError.isInteractionRequiredError(error.errorCode, error.errorMessage, error.subError);
        var isUserCancellationError = !!error && error.errorMessage.includes(AzureAdB2cErrorCodes.UserCancellation);
        return {
            isInteractionRequiredError: isInteractionRequiredError,
            isUserCancellationError: isUserCancellationError
        };
    }, [
        error
    ]);
};

var ResumeSessionStateActions;
(function(ResumeSessionStateActions) {
    ResumeSessionStateActions["setSession"] = "set_session";
    ResumeSessionStateActions["removeSession"] = "remove_session";
    ResumeSessionStateActions["clearSessions"] = "clear_sessions";
    ResumeSessionStateActions["validateSessions"] = "validate_sessions";
})(ResumeSessionStateActions || (ResumeSessionStateActions = {}));

var setSession = function(dispatch) {
    return function(appKey, session) {
        dispatch({
            type: ResumeSessionStateActions.setSession,
            payload: {
                appKey: appKey,
                session: session
            }
        });
    };
};
var removeSession = function(dispatch) {
    return function(appKey, idToken) {
        dispatch({
            type: ResumeSessionStateActions.removeSession,
            payload: {
                appKey: appKey,
                idToken: idToken
            }
        });
    };
};
var clearSessions = function(dispatch) {
    return function(appKey) {
        dispatch({
            type: ResumeSessionStateActions.clearSessions,
            payload: {
                appKey: appKey
            }
        });
    };
};
var validateSessions = function(dispatch) {
    return function(appKey) {
        dispatch({
            type: ResumeSessionStateActions.validateSessions,
            payload: {
                appKey: appKey
            }
        });
    };
};

var ResumeSessionsStoreContext = /*#__PURE__*/ createContext({});

function _array_like_to_array$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes$1(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$2(arr);
}
function _define_property$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$6(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array$1(arr) {
    return _array_without_holes$1(arr) || _iterable_to_array$1(arr) || _unsupported_iterable_to_array$2(arr) || _non_iterable_spread$1();
}
function _unsupported_iterable_to_array$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$2(o, minLen);
}
var getUpdatedSessions = function(appKey, session, state) {
    var _state_appsSessions_appKey;
    var hasSession = (_state_appsSessions_appKey = state.appsSessions[appKey]) === null || _state_appsSessions_appKey === void 0 ? void 0 : _state_appsSessions_appKey.find(function(s) {
        return s.key === session.key;
    });
    if (hasSession) return state;
    var _state_appsSessions_appKey1;
    var appSessions = (_state_appsSessions_appKey1 = state.appsSessions[appKey]) !== null && _state_appsSessions_appKey1 !== void 0 ? _state_appsSessions_appKey1 : [];
    return {
        appsSessions: _object_spread_props$4(_object_spread$6({}, state.appsSessions), _define_property$6({}, appKey, _to_consumable_array$1(appSessions).concat([
            session
        ])))
    };
};
var getSessionFromMsalAccount = function(account) {
    var idTokenClaims = account.idTokenClaims;
    var _idTokenClaims_bpu;
    var userId = (_idTokenClaims_bpu = idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.bpu) !== null && _idTokenClaims_bpu !== void 0 ? _idTokenClaims_bpu : idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.oid;
    var tenantId = idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.bpt;
    var applicationCode = idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.bpa;
    return {
        key: "".concat(userId, "_").concat(tenantId, "_").concat(applicationCode),
        userId: userId,
        tenantId: tenantId,
        authMethod: idTokenClaims.amr,
        applicationCode: applicationCode,
        userName: "".concat(idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.given_name, " ").concat(idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.family_name),
        userInitials: "".concat(idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.given_name[0]).concat(idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.family_name[0]).toUpperCase(),
        idToken: account.idToken,
        expTimeMillisecond: (idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.exp) ? (idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.exp) * 1000 : undefined
    };
};

function _define_property$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$5(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var resumeSessionsStoreReducer = function(state, action) {
    switch(action.type){
        case ResumeSessionStateActions.setSession:
            return getUpdatedSessions(action.payload.appKey, action.payload.session, state);
        case ResumeSessionStateActions.removeSession:
            var _state_appsSessions_action_payload_appKey;
            var appSessions = (_state_appsSessions_action_payload_appKey = state.appsSessions[action.payload.appKey]) !== null && _state_appsSessions_action_payload_appKey !== void 0 ? _state_appsSessions_action_payload_appKey : [];
            return {
                appsSessions: _object_spread_props$3(_object_spread$5({}, state.appsSessions), _define_property$5({}, action.payload.appKey, appSessions.filter(function(session) {
                    return session.idToken !== action.payload.idToken;
                })))
            };
        case ResumeSessionStateActions.clearSessions:
            return {
                appsSessions: _object_spread_props$3(_object_spread$5({}, state.appsSessions), _define_property$5({}, action.payload.appKey, []))
            };
        case ResumeSessionStateActions.validateSessions:
            var _state_appsSessions_action_payload_appKey1;
            var sessions = (_state_appsSessions_action_payload_appKey1 = state.appsSessions[action.payload.appKey]) !== null && _state_appsSessions_action_payload_appKey1 !== void 0 ? _state_appsSessions_action_payload_appKey1 : [];
            return {
                appsSessions: _object_spread_props$3(_object_spread$5({}, state.appsSessions), _define_property$5({}, action.payload.appKey, sessions === null || sessions === void 0 ? void 0 : sessions.filter(function(session) {
                    return session.expTimeMillisecond && session.expTimeMillisecond > new Date().getTime();
                })))
            };
        default:
            return state;
    }
};

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
var getInitResumeSessionsState = function() {
    var persistedState = localStorage.getItem(MsalLocalStorageKeys.BpMsalSessions);
    if (persistedState) return JSON.parse(persistedState);
    return {
        appsSessions: {}
    };
};
var ResumeSessionsStoreProvider = function(param) {
    var children = param.children, enable = param.enable;
    var _useReducer = _sliced_to_array(useReducer(resumeSessionsStoreReducer, getInitResumeSessionsState()), 2), state = _useReducer[0], dispatch = _useReducer[1];
    useEffect(function() {
        if (enable) {
            localStorage.setItem(MsalLocalStorageKeys.BpMsalSessions, JSON.stringify(state));
        }
    }, [
        enable,
        state
    ]);
    if (!enable) return children;
    return /*#__PURE__*/ jsx(ResumeSessionsStoreContext.Provider, {
        value: {
            state: state,
            actions: {
                setSession: setSession(dispatch),
                removeSession: removeSession(dispatch),
                clearSessions: clearSessions(dispatch),
                validateSessions: validateSessions(dispatch)
            }
        },
        children: children
    });
};

function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties$1(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BestPracticeSvgLogo = function(_param) {
    var isBlue = _param.isBlue, restSvgProps = _object_without_properties$1(_param, [
        "isBlue"
    ]);
    var color = isBlue ? "#143257" : "white";
    return /*#__PURE__*/ jsxs("svg", _object_spread_props$2(_object_spread$4({
        width: "100",
        height: "76",
        viewBox: "0 0 100 76"
    }, restSvgProps), {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_8572_204)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        d: "M55.4398 53.2911C55.1371 52.6029 54.4918 52.4121 53.8465 52.4491C52.9355 52.5017 51.9982 52.5805 51.1319 52.8453C48.1458 53.7592 45.694 55.5092 43.6461 57.851C43.4885 58.0311 43.2091 58.1683 42.9707 58.1995C42.2056 58.2988 41.4289 58.3046 40.6639 58.4068C38.5615 58.6881 36.4416 58.8954 34.3685 59.3276C32.0384 59.8132 29.9097 60.7827 28.4059 62.7653C27.382 64.1163 26.8467 65.5685 27.5222 67.2494C27.8589 68.0874 28.4819 68.6081 29.388 68.7736C29.1573 68.6481 28.8994 68.5556 28.7018 68.3901C27.7227 67.5716 27.3655 66.5233 27.6711 65.2833C27.9193 64.274 28.5101 63.4564 29.2527 62.7507C30.4947 61.5711 32.0121 60.8985 33.6541 60.5296C36.3463 59.9252 39.092 59.7821 41.8406 59.7033C41.9224 59.7013 42.0041 59.7325 42.1443 59.7587C41.7394 60.4118 41.354 61.0172 40.9841 61.6343C39.7772 63.6481 38.6326 65.6931 38.0272 67.9862C37.9143 68.4154 37.7994 68.8164 37.7595 69.2914C37.7108 69.6175 37.8549 69.9426 38.1712 69.9883C38.8175 70.0905 39.1552 69.4861 39.2292 69.342C39.9553 67.9482 40.6542 66.5398 41.4017 65.1587C42.3117 63.4778 43.2685 61.8212 44.1912 60.1471C44.455 59.6692 44.8521 59.5534 45.3631 59.5076C47.4265 59.3227 49.4549 58.9869 51.3392 58.0457C52.7904 57.3216 54.1278 56.467 55.0826 55.117C55.4749 54.5622 55.7367 53.9704 55.4379 53.2901L55.4398 53.2911ZM54.0713 54.1339C54.0431 54.2001 54.01 54.2614 53.9672 54.315C53.2129 55.2464 52.2113 55.8577 51.1485 56.3599C49.6398 57.0724 48.0669 57.598 46.3977 57.7887C46.314 57.7985 46.2293 57.7897 45.9986 57.7897C46.4911 57.307 46.8668 56.8884 47.2932 56.5303C48.4543 55.553 49.6807 54.6488 51.1047 54.1086C51.3013 54.0337 51.5018 53.9695 51.7042 53.9149C52.2415 53.769 52.7943 53.6862 53.3433 53.5908C53.5506 53.5548 53.8066 53.5013 53.975 53.6629C54.1005 53.7826 54.1404 53.9753 54.0723 54.1349L54.0713 54.1339Z",
                        fill: color
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M38.6014 61.8767C38.6608 61.7073 38.6491 61.5195 38.5664 61.3599C38.5275 61.2849 38.4846 61.2246 38.4282 61.2061C38.2802 61.1594 38.0418 61.2119 37.9201 61.3151C37.7469 61.4621 37.6232 61.6811 37.5162 61.8894C37.1015 62.6923 36.6772 63.4914 36.3044 64.3149C35.8586 65.2999 35.4518 66.3024 35.0508 67.3059C34.9194 67.6339 34.786 68.0505 35.2338 68.2315C35.6484 68.3989 35.7944 67.9862 35.9423 67.7166C36.7492 66.2508 37.5921 64.8015 38.1372 63.2082C38.2861 62.7722 38.4399 62.3381 38.6014 61.8777V61.8767Z",
                        fill: color
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M42.7653 53.4244L42.9093 53.3611C42.8665 53.3796 42.8227 53.3972 42.7799 53.4166C42.775 53.4186 42.7701 53.4225 42.7653 53.4254V53.4244Z",
                        fill: color
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M29.8737 46.3418C31.4134 45.786 32.6632 44.7932 33.8234 43.668C34.3889 43.1191 34.3918 43.1337 34.7363 43.8267C34.9271 44.2102 35.185 44.5401 35.661 44.5664C36.1866 44.5956 36.6411 44.4321 36.9059 43.9523C37.047 43.6963 37.1395 43.4082 37.2183 43.1249C37.5268 42.0222 37.0159 40.7569 36.0299 40.1495C35.1247 39.5928 33.9606 39.7534 33.0817 40.5651C32.8754 40.7559 32.6758 40.9574 32.4919 41.1705C31.2645 42.5993 29.7481 43.4179 27.8307 43.379C26.432 43.3507 25.1424 42.9011 23.9306 42.247C21.8701 41.1345 20.1619 39.5928 18.5987 37.8593C16.3757 35.3949 14.5935 32.6384 13.0732 29.7048C11.5879 26.8384 10.3236 23.8698 9.39798 20.7795C8.84222 19.1268 8.34193 16.1251 7.26447 11.0259C7.44745 11.7082 10.9397 15.6608 12.5924 17.223C14.2451 18.8562 15.9864 20.4116 17.7889 21.8774C19.1759 23.0055 20.7011 23.9681 22.1952 24.957C24.7414 26.6418 27.4803 27.9675 30.3087 29.0975C33.3922 30.3297 36.5788 31.2086 39.8735 31.6729C41.8756 31.9552 43.8738 31.8452 45.8692 31.6116C45.9022 31.6077 45.9334 31.595 45.9645 31.5775C46.1689 31.4588 46.13 31.1298 45.9022 31.0646C45.8828 31.0587 45.8633 31.0558 45.8438 31.0548C45.3251 31.0276 44.8024 31.0801 44.2846 31.048C42.8947 30.9614 41.4863 30.9565 40.1207 30.719C37.8519 30.3248 35.6756 29.5705 33.5236 28.7393C31.3044 27.8818 29.1398 26.9124 27.0676 25.7512C25.4392 24.8383 23.8128 23.9048 22.2779 22.8468C20.4373 21.5786 18.6338 20.2413 16.9285 18.7978C15.3255 17.441 13.8266 15.9509 12.3617 14.4413C10.3343 12.3516 8.49961 10.0964 6.95301 7.61736C6.54616 6.96523 6.35247 6.28294 6.32522 5.51986C6.27752 4.19225 6.33203 2.88217 6.65225 1.58473C6.82064 0.90244 6.47803 0.241557 5.95244 0.0614934C5.39375 -0.13025 4.74844 0.150065 4.50511 0.848907C4.254 1.57792 4.05933 2.35852 4.01262 3.12744C3.91918 4.68475 4.3377 6.17101 5.02486 7.55312C5.53099 8.57121 5.72176 9.60779 5.67796 10.7271C5.65071 11.4221 5.71884 12.1219 5.75193 12.8188C5.94368 16.8405 6.58412 20.7941 7.70149 24.6582C8.76532 28.3344 10.2594 31.8422 12.1165 35.1905C13.8032 38.2311 15.779 41.0459 18.445 43.3293C19.8417 44.5255 21.3162 45.5855 23.0663 46.1987C25.3166 46.988 27.5893 47.1642 29.8727 46.3408L29.8737 46.3418Z",
                        fill: color
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M96.8827 26.2338C96.7182 25.28 95.9512 24.6648 94.685 24.4575C92.7422 24.1383 90.8647 24.5062 89.0339 25.1106C87.426 25.6411 85.9592 26.4713 84.7201 27.6325C83.0723 29.1771 82.4776 31.2172 82.1827 33.3731C82.173 33.4481 82.1564 33.523 82.1584 33.5989C82.1584 33.6768 82.1788 33.7585 82.2148 33.8277C82.2207 33.8393 82.2284 33.852 82.2401 33.8588C82.246 33.8617 82.2518 33.8637 82.2586 33.8646C82.2644 33.8646 82.2703 33.8656 82.2761 33.8656C82.3812 33.8656 82.4786 33.8111 82.5428 33.7293C82.5944 33.6641 82.6207 33.5902 82.6547 33.5172C82.7297 33.3556 82.8056 33.194 82.8621 33.0247C83.2679 31.8158 83.8364 30.6994 84.7269 29.7767C86.7719 27.6588 89.2791 26.3896 92.1222 25.7803C92.6322 25.6713 93.1529 25.606 93.6737 25.5973C95.6524 25.5622 96.1381 26.2338 95.2164 27.5653C94.0192 29.2949 92.4064 30.5768 90.6651 31.6971C87.3257 33.8452 83.668 35.0385 79.6891 35.2205C76.7088 35.3567 73.8102 34.8457 70.9117 34.2355C69.2619 33.888 67.582 33.6661 65.9069 33.4656C65.2781 33.3906 64.6221 33.5357 63.8921 33.5863C64.1092 32.8271 64.2445 32.029 64.5666 31.3145C64.9092 30.5534 65.4163 29.8653 65.8777 29.1625C65.974 29.0156 66.1707 28.891 66.3439 28.8472C66.778 28.7382 66.9824 28.4812 66.8218 28.0744C66.1093 26.265 64.9433 24.9179 62.9704 24.4517C61.1561 24.0234 59.3711 24.2638 57.6006 24.7427C54.1317 25.682 51.3246 27.7123 48.7736 30.1398C47.0401 31.7886 45.513 33.6272 44.0559 35.5212C41.864 38.3692 39.8706 41.3543 37.9522 44.3911C35.8051 47.7899 33.7008 51.2169 31.2967 54.4454C29.7608 56.5079 28.1393 58.4925 26.1829 60.1753C25.7225 60.5705 25.2125 60.9267 24.5594 60.9151C24.1214 60.9073 23.9803 60.6562 24.171 60.2668C24.2363 60.1345 24.3073 60.005 24.3764 59.8736C24.0494 60.0673 23.7418 60.2795 23.8411 60.698C23.9365 61.0961 24.2596 61.2304 24.6236 61.2207C24.9137 61.2129 25.2203 61.1788 25.4889 61.0776C26.6102 60.6523 27.4716 59.8405 28.3213 59.0395C30.4849 57.0004 32.4394 54.7657 34.1943 52.3693C36.2966 49.4961 38.3552 46.5908 40.3884 43.6689C42.5161 40.6117 44.6574 37.5662 47.0528 34.7075C49.0325 32.3463 51.166 30.1485 53.6869 28.3547C55.7094 26.9161 57.9023 25.8581 60.3872 25.5214C62.4175 25.2459 64.2055 25.6333 65.3949 27.5186C65.5818 27.8145 65.5857 27.9985 65.3638 28.2943C64.5666 29.3592 63.7354 30.3977 63.423 31.7555C62.7339 34.7543 61.414 37.4581 59.4187 39.8087C57.9052 41.5908 56.1484 43.1209 54.2855 44.5254C51.9378 46.2949 49.5201 47.9651 46.934 49.3715C45.4361 50.1862 43.9216 50.9775 42.3711 51.6861C41.5993 52.0394 40.7359 52.2019 39.9047 52.4161C39.093 52.6244 38.7961 53.0293 38.9976 53.7446C39.1592 54.3189 39.8152 54.5642 40.4897 54.3092C40.8858 54.1593 41.2868 54.0191 41.7316 53.8575C41.7316 53.8653 41.7316 53.8721 41.7316 53.8799L42.7633 53.4244C42.7682 53.4215 42.7731 53.4176 42.7779 53.4157C42.8208 53.3972 42.8646 53.3787 42.9074 53.3602C44.0374 52.8784 45.1869 52.4423 46.3014 51.9284C48.8329 50.7605 51.1631 49.2576 53.3345 47.5164C55.3766 45.8802 57.2356 44.0475 58.9516 42.0726C60.8612 39.8749 62.5158 37.5165 63.4979 34.7416C63.7607 33.998 63.8084 33.9688 64.6153 33.9318C64.734 33.926 64.8528 33.9269 64.9715 33.925C67.3046 33.8851 69.5257 34.5537 71.7439 35.1192C73.6448 35.6049 75.531 36.0984 77.4845 36.3086C81.6814 36.7603 85.6886 36.1227 89.4543 34.1868C92.1533 32.7989 94.5321 31.0109 96.2403 28.4462C96.6822 27.7834 97.0229 27.0612 96.8798 26.2319L96.8827 26.2338Z",
                        fill: color
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M69.7086 35.7499C69.6142 35.7636 69.4507 35.7772 69.292 35.8103C65.83 36.5354 63.2497 38.5044 61.3692 41.4477C61.231 41.6638 60.9692 42.2838 61.1347 42.4094C61.2943 42.5301 61.4831 42.3296 61.5318 42.2556C62.1469 41.3358 62.874 40.4676 63.7685 39.7464C65.3774 38.4499 67.1342 37.5282 69.2794 37.5992C69.4994 37.6061 69.7232 37.5613 69.9412 37.5214C70.5369 37.4124 70.8649 37.0114 70.8075 36.479C70.7647 36.0838 70.2936 35.7499 69.7096 35.7499H69.7086Z",
                        fill: color
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_8572_204",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "92.9158",
                        height: "70",
                        fill: "white",
                        transform: "translate(4)"
                    })
                })
            })
        ]
    }));
};

var MIN_NUMBER_OF_SESSIONS = 1;

var useResumeSessionsStoreContext = function() {
    return useContext(ResumeSessionsStoreContext);
};

var stringToColour = function(str) {
    var hash = 0;
    str.split("").forEach(function(char) {
        hash = char.charCodeAt(0) + ((hash << 5) - hash);
    });
    var colour = "#";
    for(var i = 0; i < 3; i++){
        var value = hash >> i * 8 & 0xff;
        colour += value.toString(16).padStart(2, "0");
    }
    return colour;
};

var SessionsItem = function(param) {
    var session = param.session, close = param.close, resume = param.resume;
    var backgroundColor = session.userId ? stringToColour(session.userId) : undefined;
    return /*#__PURE__*/ jsxs("div", {
        className: "sessions__session",
        onClick: resume,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: "session__coin",
                style: {
                    backgroundColor: backgroundColor
                },
                children: session.userInitials
            }),
            /*#__PURE__*/ jsxs("div", {
                className: "session__description description",
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: "description__user",
                        children: session.userName
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: "description__application",
                        children: session.applicationName
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: "description__tenant",
                        children: session.tenantName
                    })
                ]
            }),
            /*#__PURE__*/ jsx("button", {
                className: "session__close",
                onClick: function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    (session === null || session === void 0 ? void 0 : session.idToken) && close(session.idToken);
                },
                children: "✕"
            })
        ]
    });
};

var SessionsList = function(param) {
    var sessions = param.sessions, appKey = param.appKey;
    var _useResumeSessionsStoreContext = useResumeSessionsStoreContext(), _useResumeSessionsStoreContext_actions = _useResumeSessionsStoreContext.actions, removeSession = _useResumeSessionsStoreContext_actions.removeSession, clearSessions = _useResumeSessionsStoreContext_actions.clearSessions;
    var onClose = function(session) {
        if (sessions.length === MIN_NUMBER_OF_SESSIONS) {
            clearSessions(appKey);
        } else {
            session.idToken && removeSession(appKey, session.idToken);
        }
    };
    return /*#__PURE__*/ jsx("div", {
        className: "dialog__sessions sessions",
        children: sessions.map(function(session) {
            return /*#__PURE__*/ jsx(SessionsItem, {
                session: session,
                close: function() {
                    onClose(session);
                },
                resume: function() {
                    return session.idToken && login({
                        resetInteractionInProgressStatus: true,
                        extraQueryParameters: {
                            // eslint-disable-next-line camelcase
                            id_token_hint: session.idToken,
                            prompt: "login"
                        }
                    });
                }
            }, session.key);
        })
    });
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var useSessionsInfo = function(bpIdApiBaseUrl, appKey) {
    var _appsSessions_appKey;
    var _useResumeSessionsStoreContext = useResumeSessionsStoreContext(), appsSessions = _useResumeSessionsStoreContext.state.appsSessions;
    return useAsync(/*#__PURE__*/ _async_to_generator(function() {
        var _appsSessions_appKey, _appsSessions_appKey1, appSessions, result, sessionsInfo;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    appSessions = (_appsSessions_appKey1 = appsSessions[appKey]) !== null && _appsSessions_appKey1 !== void 0 ? _appsSessions_appKey1 : [];
                    return [
                        4,
                        Promise.all(appSessions === null || appSessions === void 0 ? void 0 : appSessions.map(function(session) {
                            var query = queryString.stringify({
                                tenantId: session.tenantId,
                                tenantUserId: session.userId,
                                applicationCode: session.applicationCode
                            });
                            return fetch("".concat(bpIdApiBaseUrl, "/sessionInfo?").concat(query));
                        }))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        Promise.all(result.map(function(r) {
                            return r.json();
                        }))
                    ];
                case 2:
                    sessionsInfo = _state.sent();
                    return [
                        2,
                        (_appsSessions_appKey = appsSessions[appKey]) === null || _appsSessions_appKey === void 0 ? void 0 : _appsSessions_appKey.reduce(function(acc, session, index) {
                            var sessionInfo = sessionsInfo[index];
                            if (sessionInfo) {
                                var _sessionInfo_applicationDisplayName, _sessionInfo_userDisplayName, _sessionInfo_userInitials;
                                return _to_consumable_array(acc).concat([
                                    _object_spread_props$1(_object_spread$3({}, session), {
                                        applicationName: (_sessionInfo_applicationDisplayName = sessionInfo.applicationDisplayName) !== null && _sessionInfo_applicationDisplayName !== void 0 ? _sessionInfo_applicationDisplayName : session.applicationCode,
                                        tenantName: sessionInfo.tenantDisplayName,
                                        userName: (_sessionInfo_userDisplayName = sessionInfo.userDisplayName) !== null && _sessionInfo_userDisplayName !== void 0 ? _sessionInfo_userDisplayName : session.userName,
                                        userInitials: (_sessionInfo_userInitials = sessionInfo.userInitials) !== null && _sessionInfo_userInitials !== void 0 ? _sessionInfo_userInitials : session.userInitials
                                    })
                                ]);
                            }
                            return acc;
                        }, [])
                    ];
            }
        });
    }), [
        (_appsSessions_appKey = appsSessions[appKey]) === null || _appsSessions_appKey === void 0 ? void 0 : _appsSessions_appKey.length
    ]);
};

var ResumeSessionScreen = /*#__PURE__*/ memo(function(param) {
    var bpIdApiBaseUrl = param.bpIdApiBaseUrl, appKey = param.appKey, loginHint = param.loginHint;
    var _useSessionsInfo = useSessionsInfo(bpIdApiBaseUrl, appKey), tmp = _useSessionsInfo.data, sessions = tmp === void 0 ? [] : tmp, isLoading = _useSessionsInfo.isLoading;
    return /*#__PURE__*/ jsx("div", {
        className: "session-screen",
        children: /*#__PURE__*/ jsxs("div", {
            className: "session-screen__dialog dialog",
            children: [
                /*#__PURE__*/ jsxs("div", {
                    className: "dialog__header",
                    children: [
                        /*#__PURE__*/ jsx(BestPracticeSvgLogo, {
                            isBlue: true
                        }),
                        /*#__PURE__*/ jsx("h1", {
                            className: "title",
                            children: "Resume your previous session"
                        })
                    ]
                }),
                isLoading ? /*#__PURE__*/ jsx("div", {
                    className: "sessions__loading",
                    children: "Loading sessions ..."
                }) : /*#__PURE__*/ jsx(SessionsList, {
                    sessions: sessions,
                    appKey: appKey
                }),
                /*#__PURE__*/ jsx("div", {
                    className: "dialog__actions",
                    children: /*#__PURE__*/ jsx("a", {
                        className: "dialog__action",
                        onClick: function() {
                            login({
                                resetInteractionInProgressStatus: true,
                                loginHint: loginHint
                            });
                        },
                        children: "Sign in as a different user"
                    })
                })
            ]
        })
    });
});

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Sets the active account based on the provided loginHint.
 * If a loginHint is supplied and it does not match the username of the first account,
 * the user is logged out and redirected to the specified post-logout URI with the loginHint
 * encoded in the query parameters. If there is no loginHint or it matches the username,
 * the first account in the accounts array is set as the active account.
 *
 * The operation only proceeds if there are accounts available in the accounts array.
 */ var useSetActiveAccount = function(config) {
    var _useMsal = useMsal(), accounts = _useMsal.accounts, instance = _useMsal.instance;
    useEffect(function() {
        if (accounts.length) {
            var account = accounts[0];
            if (config.loginHint) {
                if (config.redirectUri && account.username && account.username !== config.loginHint) {
                    var postLogoutRedirectUri = queryString.stringifyUrl({
                        url: config.redirectUri,
                        query: _define_property$2({}, BpIdHints.Login, btoa(config.loginHint))
                    });
                    logout(_object_spread_props(_object_spread$2({}, config), {
                        postLogoutRedirectUri: postLogoutRedirectUri
                    }));
                } else {
                    instance.setActiveAccount(account);
                }
            } else {
                instance.setActiveAccount(account);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accounts
    ]);
};

var AuthenticationProviderBase = function(param) {
    var renderSpinner = param.renderSpinner, renderError = param.renderError, config = param.config, children = param.children;
    var _config_extraQueryParameters;
    var shouldForceRedirect = config.prompt === "login" || ((_config_extraQueryParameters = config.extraQueryParameters) === null || _config_extraQueryParameters === void 0 ? void 0 : _config_extraQueryParameters.prompt) === "login";
    var interactionType = shouldForceRedirect ? InteractionType.Redirect : InteractionType.Silent;
    var activeAccount = useAccount();
    var _useMsalAuthentication = useMsalAuthentication(interactionType, config), error = _useMsalAuthentication.error, login = _useMsalAuthentication.login;
    var accounts = useMsal().accounts;
    var status = useMsalProgressStatus();
    var _useMsalErrors = useMsalErrors(error), isUserCancellationError = _useMsalErrors.isUserCancellationError, isInteractionRequiredError = _useMsalErrors.isInteractionRequiredError;
    useEffect(function() {
        /** Redirect to sigh-in policy if:
     * 1. There is an interaction required error AND no Redirect should be forced
     * 2. If a user canceled a workflow
     * */ if (isInteractionRequiredError || isUserCancellationError) {
            login(InteractionType.Redirect, config);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInteractionRequiredError,
        isUserCancellationError
    ]);
    useSetActiveAccount(config);
    /** Render fallback component if:
   * 1. no errors OR logging actions in progress;
   * 2. there is pending action status OR no cached accounts OR no cached active account;
   * */ var shouldRenderFallback = (!error || isInteractionRequiredError || isUserCancellationError) && (status || !accounts.length || !activeAccount);
    if (shouldRenderFallback) return renderSpinner(status !== null && status !== void 0 ? status : InteractionStatusText.Login);
    /** Render error if:
   * 1. there is an error;
   * 2. no logging actions in progress;
   * 3. renderError prop passed;
   * */ var shouldRenderError = error && !isInteractionRequiredError && !isUserCancellationError && renderError;
    var _error_errorMessage;
    if (shouldRenderError) return renderError((_error_errorMessage = error === null || error === void 0 ? void 0 : error.errorMessage) !== null && _error_errorMessage !== void 0 ? _error_errorMessage : error.message, error === null || error === void 0 ? void 0 : error.errorCode);
    /** Render App as children */ return /*#__PURE__*/ jsx(Fragment, {
        children: children
    });
};

function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var AuthenticationProviderWrapper = function(props) {
    if (!!props.withResumeSessionsProps) return /*#__PURE__*/ jsx(AuthenticationProviderWithResumeScreen, _object_spread$1({}, props));
    return /*#__PURE__*/ jsx(AuthenticationProviderBase, _object_spread$1({}, props));
};
var AuthenticationProviderWithResumeScreen = function(_param) {
    var withResumeSessionsProps = _param.withResumeSessionsProps, rest = _object_without_properties(_param, [
        "withResumeSessionsProps"
    ]);
    var _useMsal = useMsal(), inProgress = _useMsal.inProgress, accounts = _useMsal.accounts;
    var activeAccount = useAccount();
    var _useResumeSessionsStoreContext = useResumeSessionsStoreContext(), state = _useResumeSessionsStoreContext.state, _useResumeSessionsStoreContext_actions = _useResumeSessionsStoreContext.actions, validateSessions = _useResumeSessionsStoreContext_actions.validateSessions, setSession = _useResumeSessionsStoreContext_actions.setSession;
    /** There is not no logging */ var isNoneInteractionStatus = inProgress === InteractionStatus.None;
    useEffect(function() {
        /** Validate and filter expired session */ if (withResumeSessionsProps) {
            validateSessions(withResumeSessionsProps.appKey);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function() {
        if (inProgress === "logout") {
            if (withResumeSessionsProps) {
                if ((activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.idTokenClaims) && (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.idToken)) {
                    var session = getSessionFromMsalAccount(activeAccount);
                    setSession(withResumeSessionsProps.appKey, session);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inProgress
    ]);
    /** Show ResumeSessionScreen if:
   * 1. no logging actions in progress;
   * 2. no cached accounts;
   * 3. withResumeSessions prop passed;
   * 4. there are persisted previous sessions;
   * */ var shouldShowResumeSessionScreen = !!withResumeSessionsProps && !!(state === null || state === void 0 ? void 0 : state.appsSessions[withResumeSessionsProps.appKey]) && !!(state === null || state === void 0 ? void 0 : state.appsSessions[withResumeSessionsProps.appKey].length) && isNoneInteractionStatus && !activeAccount && !accounts.length;
    return shouldShowResumeSessionScreen && withResumeSessionsProps ? /*#__PURE__*/ jsx(ResumeSessionScreen, {
        bpIdApiBaseUrl: withResumeSessionsProps === null || withResumeSessionsProps === void 0 ? void 0 : withResumeSessionsProps.bpIdApiBaseUrl,
        appKey: withResumeSessionsProps === null || withResumeSessionsProps === void 0 ? void 0 : withResumeSessionsProps.appKey,
        loginHint: rest.config.loginHint
    }) : /*#__PURE__*/ jsx(AuthenticationProviderBase, _object_spread$1({}, rest));
};

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var AuthenticationProvider = function(props) {
    var instance = getMsalInstance(props.config);
    return /*#__PURE__*/ jsx(MsalProvider, {
        instance: instance,
        children: /*#__PURE__*/ jsx(ResumeSessionsStoreProvider, {
            enable: !!props.withResumeSessionsProps,
            children: /*#__PURE__*/ jsx(AuthenticationProviderWrapper, _object_spread({}, props))
        })
    });
};

export { AuthMethod, AuthenticationProvider, AzureAdB2cErrorCodes, BpIdHints, InteractionStatusText, MsalLocalStorageKeys, getAccessToken, getActiveAccount, getAppInstance, getMsalInstance, login, logout, useAppSignOut, useMsalErrors, useMsalProgressStatus };
